module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-7.5f477fe0.png";